var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
const Img = (_a) => {
    var { src, placeholder, alt, onClick, style } = _a, rest = __rest(_a, ["src", "placeholder", "alt", "onClick", "style"]);
    const [loadedSrc, setLoadedSrc] = React.useState(null);
    const loaded = loadedSrc === src;
    const displaySrc = loaded ? src : placeholder;
    const gatedOnClick = loaded ? onClick : undefined;
    const effectiveStyle = onClick && !gatedOnClick ? Object.assign(Object.assign({}, style), { cursor: 'default' }) : style;
    return (_jsxs(_Fragment, { children: [_jsx("img", Object.assign({}, rest, { src: displaySrc, alt: loaded ? alt : (alt ? `Loading ${alt}` : 'Loading image'), onClick: gatedOnClick, style: effectiveStyle })), !loaded && (_jsx("img", { src: src, alt: "", "aria-hidden": "true", style: { display: 'none' }, onLoad: () => setLoadedSrc(src), onError: () => setLoadedSrc(null) }))] }));
};
export default Img;
